<template>
  <div
    class="d-flex pa-2 full-width overflow-hidden flex-column flex-md-row"
    v-on="$listeners"
  >
    <div class="flex-grow-0 d-flex align-center">
      <v-img
        :src="item.image_url"
        :lazy-src="item.image_url"
        :aspect-ratio="1"
        min-width="100"
      >
        <template v-slot:placeholder>
          <v-row class="fill-height ma-0" align="center" justify="center">
            <v-progress-circular
              indeterminate
              color="grey lighten-5"
            ></v-progress-circular>
          </v-row>
        </template>
      </v-img>
    </div>
    <div
      class="pl-4 pb-2 pr-4 flex-grow-1 d-flex flex-column full-width overflow-hidden"
    >
      <div
        class="font-weight-bold text-h5 text-truncate full-width"
        :title="item.name"
      >
        {{ item.name }}
      </div>
      <div class="d-flex align-center">
        <v-icon>mdi-layers-outline</v-icon>
        <div class="pa-1 pr-0">{{ item.layers_count }}</div>
        <strong class="ml-2"> {{ $t('layergroup.layer.name') }}</strong>
      </div>
      <div class="d-flex">
        <v-icon>mdi-folder</v-icon>
        <div class="pa-1 pr-0">
          {{ workspace.name || '' }}
        </div>
      </div>
      <div class="d-flex">
        <v-icon>mdi-key</v-icon>
        <div class="pa-1 pr-0">
          {{ workspace.name_geoserver }}:{{ item.name_geoserver }}
        </div>
      </div>
      <div
        class="pt-2 pb-1 d-flex align-center full-width"
        :title="item.updated_at | calcDate"
      >
        <div class="pr-1"> <v-icon>mdi-clock-outline</v-icon></div>
        <span class="text-truncate">
          {{ $t('workspace.modified') }}
          <strong class="ng-binding">{{ item.updated_at | calcDate }}</strong>
        </span>
      </div>
      <div class="mt-auto">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@service/auth-sdk'
export default {
  props: {
    workspace: { type: Object, default: () => ({}) },
    value: { type: Object, require: true, default: () => ({}) },
  },
  data: () => ({}),
  created() {},
  computed: {
    item() {
      return this.value
    },
  },
}
</script>

<style scoped></style>
